module.exports = __webpack_public_path__ + "img/07.95919525.png";